<template>
  <div class="about">
    <h1>This application was created by Eileen Plebani</h1>
  </div>
</template>
